<div class="clsCardModal">
  <div class="modal-body break-word" style="padding: 0">
    <div class="center-screen">
      <img class="{{ icon.class }}" src="{{ icon.src }}" />
      <div class="clsDlgInfo_Title">{{ title }}  <span class="clsDlgInfo_Severity">  {{severity}}  </span> {{extra}} </div> 
      
      <div class="clsDlgInfo_Text" [innerHtml]="main"></div>
      <div *ngIf="redirectData">
        <br />
        {{ redirectData.text }}
        <a [href]="redirectData.link" target="_blank">{{
          redirectData.clickWord
        }}</a>
      </div>
      <div class="clsDlgInfo_Subtext">{{ subtext }}</div>
    </div>
  </div>
 <div
    class="clsBtnsFooter "
    [ngClass]="{ clsJustifyContentCenter: buttons.length >= 1 }"
  >
    <div
      *ngFor="let item of buttons"
      (click)="item.btnFunc(this.dialogRef)"
      class="clsBtnDlg {{ item.btnText }}"
      [ngClass]="{ clsBtnDlgBlue :  item.btnText === 'Yes' }"
      style="cursor: pointer"
      data-dismiss="modal"
      >{{ item.btnText }}</div
    >
  </div>
</div>
